// Generated by ReScript, PLEASE EDIT WITH CARE

import Classnames from "classnames";
import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";

var uniqueSellingPointsList = BsCssJs$PrezzeeRibbon.style([BsCssJs$PrezzeeRibbon.children([
            BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.em(0.75)),
            BsCssJs$PrezzeeRibbon.lastChild([BsCssJs$PrezzeeRibbon.marginBottom(BsCssJs$PrezzeeRibbon.zero)])
          ])]);

var Styles = {
  uniqueSellingPointsList: uniqueSellingPointsList
};

function UniqueSellingPoints__List(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: Classnames([
                    uniqueSellingPointsList,
                    className$1
                  ])
            });
}

var ListItem;

var make = UniqueSellingPoints__List;

export {
  ListItem ,
  Styles ,
  make ,
}
/* uniqueSellingPointsList Not a pure module */
